import type { SubscriptionRouter } from "replo-publisher/src/trpc/routers/subscription";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: subscriptionRouter,
  client: subscriptionClient,
  utils: subscriptionUtils,
  options: subscriptionOptions,
} = createTrpcRouterConfig<SubscriptionRouter>({
  path: "subscription",
  queryClient: getNamespacedQueryClient("subscription"),
});

export {
  subscriptionClient,
  subscriptionRouter,
  subscriptionUtils,
  subscriptionOptions,
};
